import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const PieChartStatistics = ({ siteList = [], notificationList = [], chartLoader }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        width: 380,
        type: "pie",
      },
      labels: [],
      colors: [
        "#C681ED", // Base purple
        "#D199F1", // Slightly lighter
        "#DCB2F5", // Medium light
        "#E6CAFA", // Soft lavender
        "#F1E3FE"  // Very light purple
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length > 0 && notificationList.length > 0) {
      setChartData((prevState) => ({
        ...prevState,
        series: notificationList,
        options: {
          ...prevState.options,
          labels: siteList,
        },
      }));
    }
  }, [siteList, notificationList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">Notification Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartData.series.length > 0 && (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="pie"
            width={380}
          />
        )}
    </div>
  );
};

export default PieChartStatistics;